exports = module.exports = require("../../../../_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-validator .cube-checkbox,.cube-validator .cube-input input,.cube-validator .cube-radio,.cube-validator .cube-select,.cube-validator .cube-textarea{color:inherit}.cube-validator-msg-def{font-size:.373333rem;color:#e64340}", ""]);

// exports
